<template>
  <div class="inner-page">
    <header-on-slots>
      <template v-slot:menu-button>
        <button type="button" class="menu-button" @click.stop="isMenuActive = !isMenuActive">
          <span>Меню</span>
        </button>
      </template>
      <template v-slot:header-title>
        <div class="header-title">
          <div class="up-title">Аналитика</div>
          <div class="main-title">Рабочий стол</div>
        </div>
        <div class="spacer"></div>
      </template>
    </header-on-slots>

    <div class="page-container analitics-dashboard-page" :class="{ 'upload-data': preloaders.length > 0 }">
      <div class="head">
        <template v-for="(item, index) in topBar">
          <div :key="`top-bar-item-${index}`" class="column">
            <h4>{{ item.name }}</h4>
            <div v-if="item.code === 'installed_volume' || item.code === 'planned_volume'" class="property-count">
              {{ statValues[item.type][item.code] ? formatThousands(Math.round(statValues[item.type][item.code])) : "~" }}
              {{ item.unit }}
            </div>
            <div v-else class="property-count">
              {{ statValues[item.type][item.code] ? formatThousands(statValues[item.type][item.code]) : "~" }}
              {{ item.unit }}
            </div>
          </div>
        </template>

        <div class="spacer" />

        <router-link :to="{ name: 'ProblemsTable' }" class="section-link">Проблемы</router-link>
      </div>

      <div class="column-wrapper">
        <div class="side-column">
          <form-simple-date
            label="Период"
            placeholder="Период"
            :input-model="period"
            type="month"
            :confirm="true"
            format="MM.YYYY"
            range-separator="-"
            :range="true"
            :shortcuts="false"
            @update="updatePeriod"
          />

          <div class="side-column-content">
            <scrollbar>
              <div class="stat-group-wrapper">
                <div class="stat-group-header">Договоры</div>
                <div class="stat-group-content">
                  <dl>
                    <dt>Действуют</dt>
                    <dd>{{ statValues.contracts.valid_count }}</dd>
                    <dt>Истекают</dt>
                    <dd>{{ statValues.contracts.expiring_count }}</dd>
                    <dt>Срок действия истёк</dt>
                    <dd>{{ statValues.contracts.expired_count }}</dd>
                  </dl>
                </div>
              </div>

              <div class="stat-group-wrapper">
                <div class="stat-group-header">Места несанкционированного размещения</div>
                <div class="stat-group-content">
                  <dl>
                    <dt>Общее количество</dt>
                    <dd>{{ statValues.dumps.total_count }}</dd>
                    <dt>Количество действующих</dt>
                    <dd>{{ statValues.dumps.active_count }}</dd>
                    <dt>Количество ликвидированных</dt>
                    <dd>{{ statValues.dumps.liquidated_count }}</dd>
                    <dt>Разница между величиной ликвидированных отходов за текущий и предыдущий периоды</dt>
                    <dd>{{ statValues.dumps.liquidated_delta }} %</dd>
                  </dl>
                </div>
              </div>

              <div class="stat-group-wrapper">
                <div class="stat-group-header">Мероприятия</div>
                <div class="stat-group-content">
                  <dl>
                    <dt>Количество запланированных</dt>
                    <dd>{{ statValues.events.planned_count }}</dd>
                    <dt>Количество выполненных</dt>
                    <dd>{{ statValues.events.completed_count }}</dd>
                    <dt>
                      Разница между отношением выполненных к запланированным мероприятиями в текущий период и за прошлый период
                    </dt>
                    <dd>{{ statValues.events.completed_delta }} %</dd>
                  </dl>
                </div>
              </div>
            </scrollbar>
          </div>
        </div>
        <div class="main-column">
          <ul class="charts-filter">
            <template v-for="(filter, index) in filters">
              <li :key="`charts-filter-${index}`" :class="{ active: filter.active }" @click="onFilterClick(filter, index)">
                {{ filter.name }}
              </li>
            </template>
          </ul>

          <div v-if="isVisibleByFilter(lineCharts[0].tags)" class="chart-wrapper" :class="{ open: lineCharts[0].open }">
            <div class="chart-header" @click="onClickChartHeader(lineCharts[0], 0)">
              Количество мест накопления, не имеющих источников
            </div>
            <div v-if="lineCharts[0].open" class="chart-content">
              <line-chart
                :options="lineCharts[0].options"
                :chart-data="[
                  {
                    name: 'Количество мест накопления, не имеющих источников',
                    data: wasteAreasChartData
                  }
                ]"
              />
            </div>
          </div>

          <div v-if="isVisibleByFilter(lineCharts[1].tags)" class="chart-wrapper" :class="{ open: lineCharts[1].open }">
            <div class="chart-header" @click="onClickChartHeader(lineCharts[1], 1)">
              Количество мест накопления, не соответствующих требованиям
            </div>
            <div v-if="lineCharts[1].open" class="chart-content">
              <line-chart
                :options="lineCharts[1].options"
                :chart-data="[
                  {
                    name: 'Количество мест накопления, не соответствующих требованиям',
                    data: wasteAreasWithoutSourcesChartData
                  }
                ]"
              />
            </div>
          </div>

          <div v-if="isVisibleByFilter(lineCharts[2].tags)" class="chart-wrapper" :class="{ open: lineCharts[2].open }">
            <div class="chart-header" @click="onClickChartHeader(lineCharts[2], 2)">
              Количество источников, не имеющих мест накопления
            </div>
            <div v-if="lineCharts[2].open" class="chart-content">
              <line-chart
                :options="lineCharts[2].options"
                :chart-data="[
                  {
                    name: 'Количество источников, не имеющих мест накопления',
                    data: wasteSourcesChartData
                  }
                ]"
              />
            </div>
          </div>

          <div v-if="isVisibleByFilter(lineCharts[3].tags)" class="chart-wrapper" :class="{ open: lineCharts[3].open }">
            <div class="chart-header" @click="onClickChartHeader(lineCharts[3], 3)">
              Количество запланированных мероприятий
            </div>
            <div v-if="lineCharts[3].open" class="chart-content">
              <line-chart
                :options="lineCharts[3].options"
                :chart-data="[
                  {
                    name: 'Количество запланированных мероприятий',
                    data: plannedEventsChartData
                  }
                ]"
              />
            </div>
          </div>

          <div v-if="isVisibleByFilter(lineCharts[4].tags)" class="chart-wrapper" :class="{ open: lineCharts[4].open }">
            <div class="chart-header" @click="onClickChartHeader(lineCharts[4], 4)">
              Количество выполненных мероприятий
            </div>
            <div v-if="lineCharts[4].open" class="chart-content">
              <line-chart
                :options="lineCharts[4].options"
                :chart-data="[
                  {
                    name: 'Количество выполненных мероприятий',
                    data: completedEventsChartData
                  }
                ]"
              />
            </div>
          </div>

          <div v-if="isVisibleByFilter(lineCharts[5].tags)" class="chart-wrapper" :class="{ open: lineCharts[5].open }">
            <div class="chart-header" @click="onClickChartHeader(lineCharts[5], 5)">
              Количество ликвидированных мест несанкционированного размещения
            </div>
            <div v-if="lineCharts[5].open" class="chart-content">
              <line-chart
                :options="lineCharts[5].options"
                :chart-data="[
                  {
                    name: 'Количество ликвидированных мест несанкционированного размещения',
                    data: liquidatedDumpsChartData
                  }
                ]"
              />
            </div>
          </div>

          <!-- <div class="chart-wrapper">
            <div class="chart-header">Количество ликвидированных мест несанкционированного размещения</div>
            <div class="chart-content"></div>
          </div>
          <div class="chart-wrapper" :class="{ open: lineCharts[0].open }">
            <div class="chart-header" @click="onClickChartHeader(lineCharts[0], 0)">
              Количество источников, не имеющих мест накопления
            </div>
            <div v-if="lineCharts[0].open" class="chart-content">
              <line-chart :options="lineCharts[0].options" :chart-data="[]" :categories="[]" />
            </div>
          </div>
          <div class="chart-wrapper">
            <div class="chart-header">Количество мест накопления, не имеющих источников</div>
            <div class="chart-content"></div>
          </div>
          <div class="chart-wrapper">
            <div class="chart-header">Количество мест накопления, не соответствующих требованиям</div>
            <div class="chart-content"></div>
          </div>
          <div class="chart-wrapper">
            <div class="chart-header">Количество запланированных мероприятий</div>
            <div class="chart-content"></div>
          </div>
          <div class="chart-wrapper">
            <div class="chart-header">Количество выполненных мероприятий</div>
            <div class="chart-content"></div>
          </div> -->
        </div>
      </div>
    </div>

    <main-nav-menu :is-menu-active="isMenuActive" @close-menu="isMenuActive = false" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";

import HeaderOnSlots from "../../../components/HeaderOnSlots";
import MainNavMenu from "../../../components/MainNavMenu";
import FormSimpleDate from "../../../components/forms/FormSimpleDate";
import { formatThousands } from "../../../common";
import { nprogressMixin } from "../../../mixins";

import LineChart from "./LineChart";

export default {
  name: "AnaliticsDashboard",
  components: {
    HeaderOnSlots,
    MainNavMenu,
    FormSimpleDate,
    LineChart
  },
  mixins: [nprogressMixin],
  data() {
    return {
      isMenuActive: false,
      preloaders: [],
      formatLineChartsByDays: false,
      period: [
        moment()
          .startOf("year")
          .toDate(),
        moment()
          .endOf("year")
          .toDate()
      ],
      filters: [
        { name: "Источники образования", tag: "waste-sources", active: false },
        { name: "Места несанкционированного размещения", tag: "dumps", active: false },
        { name: "Места накопления", tag: "waste-areas", active: false },
        { name: "Проблемы", tag: "events", active: false }
      ],
      topBar: [
        {
          type: "containers",
          code: "installed_count",
          name: "Кол-во установленных контейнеров",
          unit: "шт."
        },
        {
          type: "containers",
          code: "installed_volume",
          name: "Объём установленных контейнеров",
          unit: "куб. м."
        },
        {
          type: "containers",
          code: "planned_count",
          name: "Кол-во планируемых контейнеров",
          unit: "шт."
        },
        {
          type: "containers",
          code: "planned_volume",
          name: "Объём планируемых контейнеров",
          unit: "куб. м."
        }
      ],
      lineCharts: [
        {
          open: false,
          tags: ["waste-areas"],
          options: {
            chart: { id: "chart-1" },
            colors: ["#89D2FB"]
          }
        },
        {
          open: false,
          tags: ["waste-areas"],
          options: {
            chart: { id: "chart-2" },
            colors: ["#89D2FB"]
          }
        },
        {
          open: false,
          tags: ["waste-sources"],
          options: {
            chart: { id: "chart-3" },
            colors: ["#89D2FB"]
          }
        },
        {
          open: false,
          tags: ["events"],
          options: {
            chart: { id: "chart-4" },
            colors: ["#89D2FB"]
          }
        },
        {
          open: false,
          tags: ["events"],
          options: {
            chart: { id: "chart-5" },
            colors: ["#89D2FB"]
          }
        },
        {
          open: false,
          tags: ["dumps"],
          options: {
            chart: { id: "chart-6" },
            colors: ["#89D2FB"]
          }
        }
      ],
      statValues: {
        containers: {},
        dumps: {},
        "waste-areas": {},
        "waste-sources": {},
        events: {},
        contracts: {}
      },
      wasteAreasChartData: [],
      wasteAreasWithoutSourcesChartData: [],
      liquidatedDumpsChartData: [],
      wasteSourcesChartData: [],
      plannedEventsChartData: [],
      completedEventsChartData: [],
      contractsChartData: []
    };
  },
  computed: {},
  watch: {
    period() {
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    ...mapActions(["getSource"]),
    onFilterClick(item, index) {
      this.filters = [...this.filters.slice(0, index), { ...item, active: !item.active }, ...this.filters.slice(index + 1)];
    },
    onClickChartHeader(item, index) {
      this.lineCharts = [...this.lineCharts.slice(0, index), { ...item, open: !item.open }, ...this.lineCharts.slice(index + 1)];
    },
    formatThousands(number) {
      return formatThousands(number);
    },
    showPreloader(preloader) {
      if (!this.preloaders.includes(preloader)) {
        this.preloaders.push(preloader);
      }
    },
    hidePreloader(preloader) {
      if (this.preloaders.includes(preloader)) {
        this.preloaders = this.preloaders.filter(item => {
          return item !== preloader;
        });
      }
    },
    getChartCategoriesByDateRange(startDate, endDate) {
      const dateStart = moment(startDate);
      const dateEnd = moment(endDate);
      const startYear = dateStart.format("YYYY");
      const endYear = dateEnd.format("YYYY");
      const startMonth = dateStart.format("M");
      const endMonth = dateEnd.format("M");

      const interim = dateStart.clone();
      const timeValues = [];

      if (startYear === endYear && startMonth === endMonth) {
        this.formatLineChartsByDays = false;
        while (dateEnd > interim || interim.format("D") === dateEnd.format("D")) {
          timeValues.push(interim.toDate());
          interim.add(1, "day");
        }

        return timeValues;
      } else {
        this.formatLineChartsByDays = true;
        while (dateEnd > interim || interim.format("M") === dateEnd.format("M")) {
          timeValues.push(interim.toDate());
          interim.add(1, "month");
        }

        return timeValues;
      }
    },
    updatePeriod(data) {
      this.period = [moment(data.value[0]).toDate(), moment(data.value[1]).toDate()];
    },
    getData() {
      const startDate = moment(this.period[0]).format("YYYY-MM-DD");
      const endDate = moment(this.period[1]).format("YYYY-MM-DD");

      // Места несанкционированного размещения
      this.showPreloader("dumps");
      this.getSource({
        url: "/api/dashboard/dumps/",
        params: {
          start_date: startDate,
          end_date: endDate
        }
      }).then(response => {
        this.hidePreloader("dumps");

        if (this.statValues.dumps) {
          this.statValues.dumps = {
            total_count: response.data.total_count,
            liquidated_count: response.data.liquidated_count,
            active_count: response.data.active_count,
            liquidated_delta: response.data.liquidated_delta
          };
        }

        if (response.data.liquidated_by_days) {
          this.liquidatedDumpsChartData = this.getChartData(response.data.liquidated_by_days, 1, startDate, endDate);
        }
      });

      // МСиНы
      this.showPreloader("waste-areas");
      this.getSource({
        url: "/api/dashboard/waste-areas/",
        params: {
          start_date: startDate,
          end_date: endDate
        }
      }).then(response => {
        this.hidePreloader("waste-areas");
        // if (this.statValues["waste-areas"]) {
        //   this.statValues["waste-areas"] = {
        //     ...this.statValues["waste-areas"],
        //     chartData: this.getChartData(response.data.daily_stats, startDate, endDate)
        //   };
        // }

        if (response.data.daily_stats) {
          this.wasteAreasChartData = this.getChartData(response.data.daily_stats, 2, startDate, endDate);
          this.wasteAreasWithoutSourcesChartData = this.getChartData(response.data.daily_stats, 1, startDate, endDate);
        }
      });

      // Контейнеры
      this.showPreloader("containers");
      this.getSource({
        url: "/api/dashboard/containers/",
        params: {
          start_date: startDate,
          end_date: endDate
        }
      }).then(response => {
        this.hidePreloader("containers");

        if (this.statValues.containers) {
          this.statValues.containers = {
            ...response.data
          };
        }
      });

      // Источники накопления отходов
      this.showPreloader("waste-sources");
      this.getSource({
        url: "/api/dashboard/waste-sources/",
        params: {
          start_date: startDate,
          end_date: endDate
        }
      }).then(response => {
        this.hidePreloader("waste-sources");

        // if (this.data["waste-sources"]) {
        //   this.data["sate-sources"] = {
        //     ...this.data["waste-sources"],
        //     chartData: response.data.daily_stats
        //   };
        // }

        if (response.data.daily_stats) {
          this.wasteSourcesChartData = this.getChartData(response.data.daily_stats, 1, startDate, endDate);
        }
      });

      // События
      this.showPreloader("events");
      this.getSource({
        url: "/api/dashboard/events/",
        params: {
          start_date: startDate,
          end_date: endDate
        }
      }).then(response => {
        this.hidePreloader("events");

        if (this.statValues.events) {
          this.statValues.events = {
            planned_count: response.data.planned_count,
            completed_count: response.data.completed_count,
            completed_delta: response.data.completed_delta
          };
        }

        if (response.data.daily_stats) {
          this.plannedEventsChartData = this.getChartData(response.data.daily_stats, 1, startDate, endDate);
          this.completedEventsChartData = this.getChartData(response.data.daily_stats, 2, startDate, endDate);
        }
      });

      // Договоры
      this.showPreloader("contracts");
      this.getSource({
        url: "/api/dashboard/contracts/",
        params: {
          start_date: startDate,
          end_date: endDate
        }
      }).then(response => {
        this.hidePreloader("contracts");

        if (this.statValues.contracts) {
          this.statValues.contracts = {
            valid_count: response.data.valid_count,
            expired_count: response.data.expired_count,
            expiring_count: response.data.expiring_count
          };
        }

        if (response.data.dayly_stats) {
          this.contractsChartData = this.getChartData(response.data.dayly_stats, 1, startDate, endDate);
        }
      });
    },
    getChartData(data, valueIndex, startDate, endDate) {
      let resultArray = [];
      let fillGroups = [];
      const dataArray = data.values.reduce((acc, item) => {
        if (item[valueIndex] > 0) {
          return [...acc, { x: item[0], y: item[valueIndex] }];
        }
        return acc;
      }, []);

      if (dataArray.length > 0) {
        if (moment(startDate).isBefore(dataArray[0].x)) {
          resultArray.push({ x: startDate, y: 0 });
        }

        resultArray = [...resultArray, ...dataArray];

        if (moment(endDate).isAfter(dataArray[dataArray.length - 1].x)) {
          resultArray.push({ x: endDate, y: dataArray[dataArray.length - 1].y });
        }

        for (let i = 0; i <= dataArray.length; i++) {
          fillGroups.push([resultArray[i], resultArray[i + 1]]);
        }

        fillGroups = fillGroups.map(range => {
          const dateStart = moment(range[0].x, "YYYY-MM-DD");
          const dateEnd = moment(range[1].x, "YYYY-MM-DD");
          const interim = dateStart.clone();
          const timeValues = [];

          while (interim.isBefore(dateEnd)) {
            timeValues.push({ x: interim.format("YYYY-MM-DD"), y: range[0].y });
            interim.add(1, "day");
          }

          return timeValues;
        });

        return [...fillGroups.flat(), resultArray[resultArray.length - 1]];
      }

      return [];
    },
    moment(date) {
      return moment(date);
    },
    isVisibleByFilter(tags) {
      const visibleFilters = this.filters.reduce((acc, item) => {
        if (item.active) {
          return [...acc, item.tag];
        }
        return acc;
      }, []);

      if (visibleFilters.length === 0) {
        return true;
      } else {
        return visibleFilters.some(tag => tags.includes(tag));
      }
    }
  }
};
</script>
